import ko from "knockout";
import metaCache from "flow/utils/metaCache";
import MyFlow from "flow/MyFlow";

interface IUiCultureInMeta {
    name: string;
    isocode: string;
    active: boolean;
}

interface ILanguageOption {
    name: string;
    isoCode: string;
}

export default function LanguageSelectorViewModel(myFlow: MyFlow) {
    const languageOptions = ko.observableArray<ILanguageOption>([]);
    const selectedLanguage = ko.observable();

    function activate() {
        initializeLanguageOptions();
        selectSelectedLanguage();
    }

    function selectSelectedLanguage() {
        const currentUiCultureIsoCode = myFlow.getUiCulture();
        const languageOption = languageOptions().find(language => {
            return language.isoCode === currentUiCultureIsoCode;
        });
        if (languageOption) {
            selectedLanguage(languageOption.isoCode);
        } else {
            selectedLanguage(metaCache.lookup("Common.Culture.defaultLanguage", "fi-FI"));
        }
    }

    function initializeLanguageOptions() {
        if (languageOptions().length < 1) {
            const uiCultures = metaCache.lookup("Common.Culture.uicultures");
            const activeLanguageOptions: ILanguageOption[] = Object.values<IUiCultureInMeta>(uiCultures)
                .filter(c => c.active)
                .map(c => ({
                    name: c.name,
                    isoCode: c.isocode
                }))
                .sort((a, b) => (a.name > b.name ? 1 : -1));
            languageOptions(activeLanguageOptions);
        }
    }

    function onSelectButtonClicked(option: ILanguageOption) {
        if (option?.isoCode) {
            if (selectedLanguage() === option.isoCode) {
                return;
            }
            selectedLanguage(option.isoCode);
        }
        window.location.href = "?uiculture=" + selectedLanguage();
    }

    return {
        activate,
        languageOptions,
        selectedLanguage,
        onSelectButtonClicked
    };
}
